import { isEqual } from 'lodash'

import { CheckboxGroupResultObject } from 'common/interfaces'

const equal = (
  target: string | number | CheckboxGroupResultObject,
  value: string | number | CheckboxGroupResultObject
): boolean => isEqual(target, value)

const regex = (target: string, value: string | RegExp): boolean =>
  new RegExp(value).test(target ?? '')

function includes(target: string, values: string[]): boolean
function includes(target: CheckboxGroupResultObject, values: CheckboxGroupResultObject): boolean
function includes(
  target: string | CheckboxGroupResultObject,
  values: string[] | CheckboxGroupResultObject
): boolean {
  if (typeof target === 'string') {
    return (values as string[]).includes(target)
  }

  return Object.entries(values as CheckboxGroupResultObject).every(
    ([key, value]) => target?.[key] === value
  )
}

const less = (target: number | string, limit: number): boolean => target < limit

const more = (target: number | string, limit: number): boolean => target > limit

const conditionsMap = {
  equal,
  regex,
  includes,
  less,
  more,
}

export { conditionsMap }
